import * as R from 'ramda';

export default function ComponentLevelController(
  $q,
  $rootScope,
  $scope,
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  serviceIds,
) {
  const vm = this;

  // Set Default Values
  vm.serviceId = serviceIds.ECAT;
  vm.isExpanded = false;

  // Attach Event Handlers
  vm.handleExpand = _handleExpand;

  _activate();

  _initEventListeners();

  // //////// METHODS //////////

  function _activate() {
    userService.getUserPermissionSet('ecat').then((permissions) => {
      vm.permissions = permissions;
    });

    R.forEach((levelControl) => {
      levelControl.maturityAssessment = null;
      R.forEach((maturityAssessment) => {
        if (levelControl.maturityAssessmentId === maturityAssessment.maturityAssessmentId) {
          levelControl.maturityAssessment = maturityAssessment;
        }
      },
      vm.componentLevel.maturityAssessments);
    },
    vm.componentLevel.levelControls);
  }

  function _initEventListeners() {
    $scope.$on('refreshComponentLevelInformation', (event, opt) => {
      if (opt.componentLevelId === vm.componentLevel.componentLevelId) {
        _refreshComponentLevelInformation();
      }
    });
  }

  function _handleExpand() {
    vm.isExpanded = !vm.isExpanded;
  }

  function _refreshComponentLevelInformation() {
    let selectedCount = 0;
    const allCount = vm.componentLevel.levelControls.length;
    R.forEach((levelControl) => {
      if (levelControl.controlMaturityAssessment.selected) {
        selectedCount += 1;
      }
    }, vm.componentLevel.levelControls);

    vm.componentLevel.summary = `${selectedCount}/${allCount}`;

    if (selectedCount === allCount) {
      vm.componentLevel.summaryStatus = 'Achieved';
    } else if (selectedCount === 0) {
      vm.componentLevel.summaryStatus = 'Not Started';
    } else {
      vm.componentLevel.summaryStatus = 'In-Progress';
    }

    $rootScope.$broadcast('refreshContributionComponentInformation', {
      contributionComponentId: vm.contributionComponentId
    });
  }
}

ComponentLevelController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'ecatDataService',
  'ecatSharedModelService',
  'confirmDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'userService',
  'serviceIds'
];
